import React, { useEffect, useState, useReducer, useContext } from "react";
import Reducer from "../components/Reducer";
import PropTypes from "prop-types";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";

import PriorityBadge from "../shared/PriorityBadge";
import SmallStatusBadge from "../shared/SmallStatusBadge";
import { TableAlert } from "./TableAlert";
import { Settings } from "../helpers/Contexts";
import * as CONST from "../helpers/Constants";

const TaskFieldFilter = ({ name }) => {
  const [showTaskFieldFilters, setShowTaskFieldFilters] = useState(null);
  const settings = useContext(Settings);

  let optionValues = null;
  if (name == "PCP Group") {
    optionValues = settings.pcp_groups.map((i, e) => {
      return (
        <option key={i.name} value={i.name}>
          {i.name}
        </option>
      );
    });
  } else if (name == "Assignee") {
    optionValues = settings.support_groups.map((i, e) => {
      return (
        <option key={i.name} value={"assignee:'" + i.name + "'"}>
          {i.name}
        </option>
      );
    });
  } else {
    optionValues = CONST.TASK_LABELS.map((i) => {
      return (
        <option key={i.value} value={i.value}>
          {i.label}
        </option>
      );
    });
  }

  return (
    <>
      <div
        className={
          showTaskFieldFilters == true ? "green-text float-right" : "gray-text float-right"
        }
        onClick={() => setShowTaskFieldFilters(!showTaskFieldFilters)}
      >
        <i className="fa fa-filter" />
      </div>

      {showTaskFieldFilters == true && (
        <div className="task-field-filter">
          <h5 className="text-left">
            Filter:
            <a onClick={() => setShowTaskFieldFilters(false)} className="float-right">
              <i className="fa fa-times red-text"></i>
            </a>
          </h5>
          <select
            className="form-control"
            onChange={(el) => {
              var input = document.querySelector("input.search-tasks");
              var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                "value"
              ).set;
              nativeInputValueSetter.call(input, el.target.value);
              var inputEvent = new Event("input", { bubbles: true });
              input.dispatchEvent(inputEvent);
              setShowTaskFieldFilters(false);
            }}
          >
            <option>--</option>
            {optionValues}
          </select>
        </div>
      )}
    </>
  );
};

export default TaskFieldFilter;
